import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../../hooks/useAuth';
import { useCart } from '../../hooks/useCart';
import { env } from '../../config/env';

export const Navbar: React.FC = () => {
    const { itemCount } = useCart();
    const { isAuthenticated, logout } = useAuth();
    const navigate = useNavigate();

    const handleLogout = async () => {
        await logout();
        navigate('/');
    };

    const handleUserClick = () => {
        if (isAuthenticated) {
            navigate('/profile');
        } else {
            navigate('/login');
        }
    };

    return (
        <header className="sticky top-0 z-50 w-full border-b border-solid border-gray-200 dark:border-gray-800 bg-white/80 dark:bg-background-dark/80 backdrop-blur-md">
            <div className="max-w-[1280px] mx-auto flex h-16 items-center justify-between px-6 lg:px-10">
                <div className="flex items-center gap-8">
                    <Link to="/" className="flex items-center gap-3">
                        {env.LOGO_URL ? (
                            <img src={env.LOGO_URL} alt={env.COMPANY_NAME} className="size-8 rounded-lg object-cover" />
                        ) : (
                            <div className="size-8 bg-primary rounded-lg flex items-center justify-center text-white">
                                <span className="material-symbols-outlined">shopping_bag</span>
                            </div>
                        )}
                        <h2 className="text-xl font-bold tracking-tight uppercase">{env.COMPANY_NAME}</h2>
                    </Link>
                    {/* Navigation items removed as per requirements */}
                    <nav className="hidden md:flex items-center gap-6">
                        {/* <Link to="/products" className="text-sm font-semibold hover:text-primary transition-colors">Shop</Link>
                        <Link to="/categories" className="text-sm font-semibold hover:text-primary transition-colors">Categories</Link>
                        <Link to="/sale" className="text-sm font-semibold hover:text-primary transition-colors">Sale</Link> */}
                    </nav>
                </div>
                <div className="flex flex-1 items-center gap-4 ml-8">
                    <div className="hidden md:flex flex-1 items-center relative gap-2">
                        <input
                            className="w-full h-10 rounded-lg border-none bg-gray-100 dark:bg-gray-800 px-4 text-sm focus:ring-2 focus:ring-primary transition-all"
                            placeholder="Search products..."
                            type="text"
                            onKeyDown={(e) => {
                                if (e.key === 'Enter') {
                                    const val = (e.target as HTMLInputElement).value;
                                    if (val.trim()) {
                                        navigate(`/products?q=${encodeURIComponent(val)}`);
                                    }
                                }
                            }}
                            ref={() => {}}
                        />
                        <button
                            onClick={(e) => {
                                const input = e.currentTarget.previousElementSibling as HTMLInputElement;
                                if (input && input.value.trim()) {
                                    navigate(`/products?q=${encodeURIComponent(input.value)}`);
                                }
                            }}
                            className="h-10 px-6 bg-primary text-white rounded-lg font-bold text-sm hover:bg-primary/90 transition-colors whitespace-nowrap"
                        >
                            Search
                        </button>
                    </div>
                    <div className="flex items-center gap-2">
                        <button
                            onClick={handleUserClick}
                            className="p-2 hover:bg-gray-100 dark:hover:bg-gray-800 rounded-full transition-colors relative"
                        >
                            <span className="material-symbols-outlined">person</span>
                        </button>
                        {isAuthenticated && (
                            <button
                                onClick={handleLogout}
                                className="p-2 hover:bg-gray-100 dark:hover:bg-gray-800 rounded-full transition-colors relative"
                                title="Logout"
                            >
                                <span className="material-symbols-outlined">logout</span>
                            </button>
                        )}
                        <Link to="/cart" className="p-2 hover:bg-gray-100 dark:hover:bg-gray-800 rounded-full transition-colors relative">
                            <span className="material-symbols-outlined">shopping_cart</span>
                            {itemCount > 0 && (
                                <span className="absolute top-1 right-1 flex h-4 w-4 items-center justify-center rounded-full bg-primary text-[10px] font-bold text-white">
                                    {itemCount > 99 ? '99+' : itemCount}
                                </span>
                            )}
                        </Link>
                        <button className="lg:hidden p-2 hover:bg-gray-100 dark:hover:bg-gray-800 rounded-full transition-colors">
                            <span className="material-symbols-outlined">menu</span>
                        </button>
                    </div>
                </div>
            </div>
        </header>
    );
};
